import { Box, Typography, styled } from '@mui/material';
import { ErrorIcon } from '../icons/ErrorIcon';
import { palette } from '../../theme/palette';

export const RootContainer = styled(Box)`
  padding-top: 9px;
  display: flex;
  gap: 15px;
`;

export const ErrorIconWrapper = styled(Box)`
  width: 13px;
  height: 13px;
`;

export const StyledErrorIcon = styled(ErrorIcon)`
  max-width: 100%;
  max-height: 100%;
`;

export const ErrorInfoWrapper = styled(Box)``;

export const ErrorInfo = styled(Typography)`
  color: ${palette.custom.darkGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.35px;
`;

export const ErrorHeader = styled(ErrorInfo)`
  color: #da344d;
  font-weight: 700;
`;
